
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment améliorer l’accessibilité de votre site web efficacement",
    description:
      "Rendez votre site plus accessible et inclusif grâce à nos conseils pratiques : UX, SEO, navigation optimisée. ALEO vous accompagne dans cette démarche essentielle.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
